
/**
 * 生成uuid方法
 * @returns {string}
 */
export const createUUID = function () {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};
/**
 * 获取画布上的特定类型的列表
 * @param {画布上所有对象} objects 
 * @param {*} type 
 * @returns 
 */
export const getObjectsFromType = function (objects, type) {
  return new Promise(resolve => {
    const list = [];
    objects.forEach(item => {
      if (item.id == type) {
        list.push(item);
      }
    })
    resolve(list);
  })

}

function dataURItoBlob(dataURI) {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

export async function getVideoCover(url) {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = url;
    video.preload = "auto";
    video.onloadeddata = () => {
      const canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL();
      const blob = dataURItoBlob(dataUrl);
      resolve(URL.createObjectURL(blob));
    };
    video.onerror = () => {
      console.log("onerror");
      reject();
    };
  });
}

export function getDDExtra(obj) {
  if (!obj.ddExtra) {
    obj.ddExtra = {};
  }
  return obj.ddExtra;
}